import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './RTModal.css';

const RTModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer, 
  size = 'medium', // small, medium, large
  disableBackdropClick = false // New prop to disable closing on backdrop click
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && onClose && !disableBackdropClick) {
      onClose();
    }
  };

  return (
    <div className="rt-modal-overlay" onClick={handleOverlayClick}>
      <div className={`rt-modal ${size}`}>
        <div className="rt-modal-header">
          <h3 className="rt-modal-title">{title}</h3>
          {onClose && (
            <button 
              className="rt-modal-close"
              onClick={onClose}
              aria-label="Close modal"
            >
              <FaTimes />
            </button>
          )}
        </div>
        
        <div className="rt-modal-body">
          {children}
        </div>
        
        {footer && (
          <div className="rt-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default RTModal;
